const prod = {
  city: process.env.REACT_APP_CITY || 'lorient',
  url: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://myapp.com/api',
    API_ROUTE_URL: process.env.REACT_APP_API_ROUTE_URL,
    GEOCODING_SERVICE_URL: process.env.REACT_APP_GEOCODING_SERVICE_URL || 'http://mygeocoder.com',
    GEOCODING_MAPTILER_URL: process.env.REACT_APP_GEOCODING_MAPTILER_URL || 'https://api.maptiler.com/geocoding',
    PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL || 'https://myapp.com/handimap',
    JSON_CONF_URL: process.env.REACT_APP_JSON_CONF_URL || 'https://myapp.com/config/json',
    LAYER_ICONS_CONF_URL: process.env.REACT_APP_LAYER_ICONS_CONF_URL || 'https://myapp.com/config/images',
    JSON_FEATURE_URL: process.env.REACT_APP_JSON_FEATURE_URL || 'https://myapp.com/layers-api/lorient',
    HOME_PAGE_URL: process.env.REACT_APP_HOME_PAGE_URL || 'https://myapp.com/',
    OBSTACLES_URL: process.env.REACT_APP_OBSTACLES_URL || 'https://dev.routing.lorient-agglo.handimap.fr/obstacles.geojson'
  },
  token: {
    MAPTILER_KEY: process.env.REACT_APP_MAPTILER_KEY,
  }
};
 
const dev = {
  city: process.env.REACT_APP_CITY || 'lorient',
  url: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000',
    API_ROUTE_URL: process.env.REACT_APP_API_ROUTE_URL,
    GEOCODING_SERVICE_URL: process.env.REACT_APP_GEOCODING_SERVICE_URL || 'http://localhost:1234',
    GEOCODING_MAPTILER_URL: process.env.REACT_APP_GEOCODING_MAPTILER_URL || 'https://api.maptiler.com/geocoding',
    PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL || 'http://localhost:3000',
    JSON_CONF_URL: process.env.REACT_APP_JSON_CONF_URL || 'https://myapp.com/config/json',
    LAYER_ICONS_CONF_URL: process.env.REACT_APP_LAYER_ICONS_CONF_URL || 'https://myapp.com/config/images',
    JSON_FEATURE_URL: process.env.REACT_APP_JSON_FEATURE_URL || 'https://myapp.com/layers-api/lorient',
    OBSTACLES_URL: process.env.REACT_APP_OBSTACLES_URL || 'https://dev.routing.lorient-agglo.handimap.fr/obstacles.geojson',
    HOME_PAGE_URL: process.env.REACT_APP_HOME_PAGE_URL || 'http://localhost:3001'
  },
  token: {
    MAPTILER_KEY: process.env.REACT_APP_MAPTILER_KEY,
  }
};

export const config = process.env.REACT_APP_NODE_ENV === 'development' ? dev : prod;